<!-- Fixed button to open the widget (unchanged) -->
<div class="help-button-container">
  <button class="help-button" (click)="toggleWidget()">
    <img src="data:image/png;base64,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" alt="why-us-male--v1">
    <span class="help-text">I need help to optimize this</span>
  </button>
</div>

<!-- Overlay semi-transparent qui ferme le widget au clic -->
<div class="widget-overlay" *ngIf="showWidget" (click)="toggleWidget()"></div>

<!-- Widget container with modal structure -->
<div class="widget-container" *ngIf="showWidget" (click)="$event.stopPropagation()">
  <div class="modal">
    <div class="modal__header">
      <span class="modal__title px-4 pt-4 pb-3">Speetals Optimization Request</span>
      <button class="button button--icon" (click)="toggleWidget()">
        <svg width="24" height="24" viewBox="0 0 24 24">
          <path fill="none" d="M0 0h24v24H0V0z"></path>
          <path fill="black" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"></path>
        </svg>
      </button>
    </div>
    <div class="modal__body">
      <form [formGroup]="helpForm" (ngSubmit)="onSubmit()">
        <!-- Issue Description -->
         <p>Please describe your optimization request and we will get back to you as soon as possible with a quote.</p>
         <p>We will specify the needed optimizations, test, and validate the results.</p>
        <div class="input">
          <label class="input__label">Description of the need</label>
          <textarea
            formControlName="description"
            required
            class="input__field input__field--textarea"
          ></textarea>
        </div>

        <!-- Screenshot -->
        <div class="input">
          <label class="input__label">Screenshot</label>
          <p>Please upload a screenshot of the graph/data you want to optimize</p>
          <input
            type="file"
            (change)="onFileSelected($event)"
            accept="image/*"
            class="input__field"
          />
        </div>

        <!-- User Story Number -->
        <div class="input">
          <label class="input__label">User Story Number</label>
          <p>Please enter the user story number (it depends on your team capacity)</p>
          <input
            type="number"
            formControlName="userStory"
            class="input__field"
          />
        </div>
      </form>
    </div>
    <div class="modal__footer">
      <button
        type="submit"
        [disabled]="!helpForm.valid"
        class="button button--primary"
        (click)="onSubmit()"
      >
        Submit
      </button>
    </div>
  </div>
</div>
